export default __webpack_public_path__ + "static/media/Rocket.a4a03d94.svg";